/** Vue  */
import Vue from 'vue';

/**  Moment */
import moment from 'moment';

import * as uiv from 'uiv';
Vue.use(uiv);

import VueSilentbox from 'vue-silentbox';
Vue.use(VueSilentbox);

import DatePicker from 'v-calendar/lib/components/date-picker.umd'
Vue.component('v-date-picker', DatePicker)

// Registra globalmente los plugin
import ShareButton from "./../plugins/ShareButton.vue";
Vue.component("share-button", ShareButton);

import AdminEditableName from "./../plugins/AdminActions/AdminEditableName.vue";
import AdminToolbar from "./../plugins/AdminActions/AdminToolbar.vue";
import AdminFilters from "./../plugins/AdminActions/AdminFilters/AdminFilters.vue";
Vue.component("admin-editable-name", AdminEditableName);
Vue.component("admin-toolbar", AdminToolbar);
Vue.component("admin-filters", AdminFilters);

import store from './store';
Vue.config.productionTip = typeof APP_DEBUG !== 'undefined' ? APP_DEBUG : false;
Vue.config.devtools = typeof APP_DEBUG !== 'undefined' ? APP_DEBUG : false;
moment.locale('es');

/**  Vue: Components */
const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => {
  Vue.component(key.split('/').pop().split('.')[0], files(key).default);
});

/**  Vue: App */
const app = new Vue({ el: '#app', store });
